import _ from 'lodash';

export function productionProcess(ftProcess: any): string {
  const type = _.get(ftProcess, 'type');
  const machine = _.get(ftProcess, 'machine');
  const rawMaterialId = _.get(ftProcess, 'inputs.0._id');
  return `${machine} -- ${type} -- ${rawMaterialId}`;
}